export const CONSENT_STORAGE_KEY = 'tvroulette-consent-v1';

export type ConsentChoice = {
  analytics: boolean;
  ads: boolean;
};

/**
 * @returns stored consent flags, or null when missing/invalid
 */
export function getStoredConsent(): ConsentChoice | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ConsentChoice>;
    if (typeof parsed.analytics !== 'boolean' || typeof parsed.ads !== 'boolean') return null;
    return { analytics: parsed.analytics, ads: parsed.ads };
  } catch {
    return null;
  }
}

export function setStoredConsent(consent: ConsentChoice): void {
  const payload = {
    analytics: consent.analytics,
    ads: consent.ads,
    updatedAt: new Date().toISOString(),
  };
  localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(payload));
}

export function hasAnalyticsConsent(): boolean {
  return Boolean(getStoredConsent()?.analytics);
}
